import React, { createContext, useState, useContext, useEffect } from 'react';
import { allSteps } from './tutorialSteps';
import JoyrideTour from './JoyrideTour';
import TutorialTrigger from './TutorialTrigger';
import { useLocation } from 'react-router-dom';

const TutorialContext = createContext();

export const TutorialProvider = ({ children }) => {
    const [run, setRun] = useState(false);
    const [steps, setSteps] = useState([]);
    const [currentTour, setCurrentTour] = useState(null);
    const [overrideTourKey, setOverrideTourKey] = useState(null);
    const location = useLocation();

    useEffect(() => {
        setOverrideTourKey(null);
    }, [location.pathname]);

    const getTutorialKey = (pathname) => {
        if (pathname.includes('categoria')) return 'category';
        if (pathname.includes('produto/novo')) return 'productNew';
        if (pathname.includes('caixas/novo')) return 'cashierNew';
        if (pathname.includes('caixas/detalhes')) return 'cashierLogistic';
        if (pathname.includes('gestao/estoque')) return 'stock';
        if (pathname.includes('servico/novo')) return 'service';
        if (pathname.includes('gestao/custos')) return 'costs';
        if (pathname.includes('gestao/planejamento')) return 'planning';
        if (pathname.includes('usuarios/novo')) return 'userNew';
        if (pathname.includes('agendamentos/agenda')) return 'scheduleAgenda';
        if (pathname.includes('clientes/perfis')) return 'customerProfiles';
        if (pathname.includes('clientes/analise')) return 'customerAnalysis';
        return null;
    };

    const tutorialKey = overrideTourKey || getTutorialKey(location.pathname);

    const startTour = (tourKey) => {
        const key = tourKey || tutorialKey;
        if (allSteps[key]) {
            setSteps(allSteps[key]);
            setCurrentTour(key);
            setRun(true);
        }
    };

    return (
        <TutorialContext.Provider value={{ startTour, currentTour, setOverrideTourKey }}>
            {children}
            <TutorialTrigger
                show={Boolean(tutorialKey) && !run}
                onStart={() => startTour(tutorialKey)}
            />
            <JoyrideTour
                steps={steps}
                run={run}
                setRun={setRun}
                onFinish={() => setCurrentTour(null)}
            />
        </TutorialContext.Provider>
    );
};

export const useTutorial = () => {
    const context = useContext(TutorialContext);
    if (!context) {
        throw new Error('useTutorial must be used within a TutorialProvider');
    }
    return context;
};
